"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutTile = void 0;
// import * as cmpts from '@lifewayit/components';
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const translations_1 = require("../../i18n/translations");
function CheckoutTile(_a) {
    var { isChecked, containerStyles, children, role = 'radio', isGiftCard = false, locale = 'en', handleGiftCardRemove } = _a, props = __rest(_a, ["isChecked", "containerStyles", "children", "role", "isGiftCard", "locale", "handleGiftCardRemove"]);
    const { removeGiftCardText } = translations_1.checkoutContent[locale];
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('flex w-full relative border-2 rounded-xl py-3 px-4 relative hover:border-yellow focus:border-yellow transition-colors', containerStyles, {
            'border-yellow shadow-md-all': isChecked,
            'border-e': !isChecked,
        }), role: role, "aria-checked": role === null ? false : isChecked ? true : false, tabIndex: 0 }, props),
        isChecked && (react_1.default.createElement(fa_1.FaCheckCircle, { className: (0, classnames_1.default)('absolute top-2 right-2', {
                'text-yellow': isChecked,
            }), size: "20px", "aria-hidden": true })),
        children,
        isGiftCard && (react_1.default.createElement("div", { className: "absolute bottom-2 right-2 cursor-pointer" },
            react_1.default.createElement("button", { onClick: handleGiftCardRemove },
                react_1.default.createElement("span", { className: "sr-only" }, removeGiftCardText),
                react_1.default.createElement(fa_1.FaRegTrashAlt, { size: "12px", "aria-hidden": true }))))));
}
exports.CheckoutTile = CheckoutTile;
